import {
  fetchConversations as fetchSharedConversations,
  type ConversationHistoryItem,
} from "@carousel-office/shared";
import { getDeckRegistry } from "../../services/tracking/deckRegistry";

export type { ConversationHistoryItem } from "@carousel-office/shared";

export async function fetchConversations(): Promise<ConversationHistoryItem[]> {
  const deckRegistry = getDeckRegistry();
  return fetchSharedConversations({
    origin: "mainTaskpane",
    primaryAgentType: "livePowerPointOrchestrator",
    resolveFallbackTitle: (conversation) => {
      const deckInfo = deckRegistry.getDeckById(conversation.presentationId);
      const deckTitle = deckInfo?.title || "";
      if (deckTitle && !deckTitle.startsWith("PowerPoint add-in ") && !deckTitle.startsWith("Untitled")) {
        return deckTitle;
      }
      return `Conversation ${String(conversation.id || "").substring(0, 8)}`;
    },
  });
}
